import { motion } from 'framer-motion'
import { FaWhatsapp } from 'react-icons/fa'
import Button from '../ui/Button'
import { BalloonLayer } from '../ui/BalloonSVG'
import { useSite } from '../../context/SiteContext'

const PHONE = '07775000'
const WA_NUMBER = '20107775000'

export default function CTA() {
  const { siteOptions } = useSite()
  const waNumber = siteOptions?.contact?.whatsapp?.replace(/\D/g, '') || WA_NUMBER

  return (
    <section
      className="py-24 relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #FF6BB5 0%, #7C3AFF 100%)' }}
    >
      {/* Decorative blobs */}
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-white/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-white/10 rounded-full blur-3xl pointer-events-none" />

      {/* Floating balloon decorations */}
      <BalloonLayer opacity={0.30} />

      <div className="container-custom relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white mb-4 text-balance">
            Your Child Deserves a Day They'll Never Forget
          </h2>
          <p className="font-body text-white/80 text-lg md:text-xl max-w-xl mx-auto mb-10 leading-relaxed">
            Let's Start Planning Together
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <Button to="/contact" size="lg" variant="dark">
              🎉 Book Your Party
            </Button>
            <Button
              href={`https://wa.me/${waNumber}`}
              size="lg"
              variant="whatsapp"
              icon={<FaWhatsapp size={20} />}
            >
              WhatsApp Us
            </Button>
            <Button
              href={`tel:${PHONE}`}
              size="lg"
              variant="phone"
            >
              📞 {PHONE}
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
